import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const LD = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M6 2.75H18C19.7949 2.75 21.25 4.20507 21.25 6V18C21.25 19.7949 19.7949 21.25 18 21.25H6C4.20507 21.25 2.75 19.7949 2.75 18V6C2.75 4.20507 4.20507 2.75 6 2.75Z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M6.77246 15.5C6.51824 15.5 6.32593 15.434 6.19556 15.302C6.06519 15.1634 6 14.9686 6 14.7178V9.28218C6 9.03135 6.06519 8.83993 6.19556 8.70792C6.32593 8.56931 6.51498 8.5 6.76269 8.5C7.26462 8.5 7.51559 8.76073 7.51559 9.28218V14.203H10.1361C10.5729 14.203 10.7912 14.4175 10.7912 14.8465C10.7912 15.2822 10.5729 15.5 10.1361 15.5H6.77246Z'
          fill='currentColor'
        />
        <path
          d='M12.3972 15.5C11.8692 15.5 11.6052 15.2327 11.6052 14.698V9.32178C11.6052 8.78713 11.8692 8.5198 12.3972 8.5198H14.3039C15.4773 8.5198 16.3866 8.82343 17.032 9.43069C17.6773 10.0314 18 10.8894 18 12.005C18 13.1205 17.6773 13.9818 17.032 14.5891C16.3866 15.1964 15.4773 15.5 14.3039 15.5H12.3972ZM13.1208 14.2426H14.2159C15.6826 14.2426 16.416 13.4967 16.416 12.005C16.416 10.5198 15.6826 9.77723 14.2159 9.77723H13.1208V14.2426Z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        d='M18 2C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2H18ZM6.7627 8.5C6.51499 8.5 6.32569 8.56939 6.19531 8.70801C6.06505 8.84002 6 9.03151 6 9.28223V14.7178C6 14.9685 6.06509 15.1632 6.19531 15.3018C6.32569 15.4338 6.51823 15.5 6.77246 15.5H10.1357C10.5724 15.5 10.791 15.2822 10.791 14.8467C10.791 14.4176 10.5725 14.2031 10.1357 14.2031H7.51562V9.28223C7.51562 8.76078 7.26463 8.5 6.7627 8.5ZM12.3975 8.51953C11.8694 8.51953 11.6055 8.78761 11.6055 9.32227V14.6982C11.6055 15.2327 11.8695 15.5 12.3975 15.5H14.3037C15.4771 15.5 16.3869 15.1961 17.0322 14.5889C17.6774 13.9816 18 13.1202 18 12.0049C18 10.8895 17.6775 10.0313 17.0322 9.43066C16.3869 8.8234 15.4771 8.51953 14.3037 8.51953H12.3975ZM14.2158 9.77734C15.6825 9.77734 16.416 10.5198 16.416 12.0049C16.416 13.4966 15.6825 14.2422 14.2158 14.2422H13.1211V9.77734H14.2158Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
